import CustomerService from "@/services/customer.service";
import { ModalConfigStruct } from "@/struct/ui/UIModalStruct";
import { Module } from "vuex";
import { SendOtpParams } from "@/struct/AuthStruct";
import { getTokenFromCookies } from "@/utils/common";
import { getChildAccounts } from "@/server/api/get-child-accounts";
import { AccountPhoneType } from "@/struct/AccountPhoneStruct";
import type { CreatePaymentType } from "@/struct/PaymentStruct";

const customerService = new CustomerService();

export interface SystemState {
  phonesList: AccountPhoneType[] | null;
}

const customerModule: Module<SystemState, any> = {
  namespaced: true,
  state: () => ({
    phonesList: null,
  }),
  getters: {},
  mutations: {
    SET_PHONES_LIST(state, payload) {
      state.phonesList = payload;
    },
  },
  actions: {
    changeMainPhone({ dispatch }, phoneNumber: string) {
      return customerService
        .changeMainCustomer(phoneNumber)
        .then((res) => {
          if (!res.status) {
            console.error("Бэкенд вернул ошибку смены телефона");
            return false;
          }
          return dispatch("tariff/updateSubscriptionDetails", null, {
            root: true,
          }).then(() => {
            return true;
          });
        })
        .catch((error) => {
          console.error("error на одном из этапов Change Main Phone", error);
          return;
        });
    },

    getUserPhoneList({ commit }) {
      customerService
        .getChildAccounts()
        .then((res) => {
          if (res?.data?.status) {
            commit("SET_PHONES_LIST", res.data.response);
          } else {
            console.error("error get User Phones List");
          }
        })
        .catch((err) => {
          console.error("error get User Phones List", err);
        });
    },

    toPaymentCart({ dispatch }, payload: CreatePaymentType) {
      customerService
        .createPayment(payload)
        .then((res) => {
          if (res?.data?.response?.REF) {
            return { success: true, REF: res.data.response?.REF };
          } else {
            dispatch(
              "system/openModal",
              { presetKey: "base_error" },
              { root: true }
            );
          }
        })
        .catch((err) => {
          dispatch(
            "system/openModal",
            { presetKey: "base_error" },
            { root: true }
          );
        });
    },
  },
};

export default customerModule;
